import { render, staticRenderFns } from "./videoInfo.vue?vue&type=template&id=af4ca2d2"
import script from "./videoInfo.vue?vue&type=script&lang=js"
export * from "./videoInfo.vue?vue&type=script&lang=js"
import style0 from "./videoInfo.vue?vue&type=style&index=0&id=af4ca2d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports